import InitAppCues from '@/integrations/InitAppCues';
import RouteMiddleware from '@/middlewares/RouteMiddleware';
import MixpanelProvider from '@/providers/MixpanelProvider/MixpanelProvider';
import SessionProvider from '@/providers/SessionProvider';
import GlobalHotKeys from '@/sections/GlobalHotKeys/GlobalHotKeys';

const SessionProviderWrapper = () => {
  return (
    <SessionProvider>
      <GlobalHotKeys />
      <InitAppCues />

      <MixpanelProvider>
        <RouteMiddleware />
      </MixpanelProvider>
    </SessionProvider>
  );
};

export default SessionProviderWrapper;
